export default __webpack_public_path__ + "static/media/ios-safari-instructions.bfbeaacf.gif";